var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4533 13.4847L18.4937 13.4746C19.0451 13.3367 19.432 12.8412 19.432 12.2728V11.7292C19.432 11.1608 19.0451 10.6653 18.4936 10.5274L18.4532 10.5173C18.0328 10.4119 17.6871 10.1136 17.5214 9.71316C17.3556 9.31269 17.3894 8.85737 17.6124 8.48573L17.6294 8.45738C17.9256 7.96914 17.8503 7.34178 17.447 6.93745L17.0627 6.55308C16.6607 6.15113 16.0368 6.07431 15.5494 6.36675L15.5136 6.38822C15.142 6.61118 14.6867 6.64487 14.2863 6.47902C13.886 6.31318 13.5878 5.96743 13.4827 5.54701L13.4726 5.50665C13.3347 4.9552 12.8392 4.56836 12.2708 4.56836H11.7272C11.1588 4.56836 10.6633 4.95521 10.5254 5.50666L10.5153 5.54713C10.41 5.96756 10.1117 6.31323 9.7112 6.47898C9.31073 6.64473 8.85541 6.61097 8.48376 6.38796L8.4554 6.37096C7.96716 6.07476 7.3398 6.15002 6.93547 6.55329L6.55111 6.93766C6.14914 7.33953 6.07229 7.96342 6.36471 8.45083L6.38586 8.48609C6.60887 8.85774 6.64264 9.31306 6.4769 9.71354C6.31115 10.114 5.96548 10.4123 5.54505 10.5176L5.50472 10.5277C4.95328 10.6656 4.56641 11.1611 4.56641 11.7295V12.2731C4.56641 12.8415 4.95306 13.3369 5.50441 13.4748L5.54448 13.4848C5.96497 13.5899 6.31081 13.888 6.47679 14.2884C6.64277 14.6887 6.60927 15.1441 6.38647 15.5159L6.36505 15.5515C6.07262 16.0389 6.14942 16.6628 6.55134 17.0648L6.93574 17.4492C7.33753 17.8511 7.96133 17.928 8.44868 17.6356L8.4841 17.6144C8.85574 17.3914 9.31107 17.3576 9.71155 17.5233C10.112 17.6891 10.4103 18.0347 10.5157 18.4552L10.5258 18.4956C10.6636 19.047 11.1591 19.4339 11.7275 19.4339H12.2712C12.8395 19.4339 13.3349 19.0472 13.4728 18.4958L13.4828 18.4558C13.5879 18.0353 13.886 17.6895 14.2864 17.5235C14.6868 17.3575 15.1421 17.391 15.5139 17.6138L15.5496 17.6353C16.037 17.9277 16.6609 17.8509 17.0628 17.449L17.4473 17.0646C17.8492 16.6628 17.926 16.039 17.6337 15.5516L17.6124 15.5162C17.3894 15.1446 17.3557 14.6892 17.5214 14.2888C17.6872 13.8883 18.0329 13.59 18.4533 13.4847Z",
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 3.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9985,
    cy: 12.0004,
    r: 1.71525,
    fill: "white",
    stroke: "white",
    strokeWidth: 3.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.b535fab0ee2a0c55e463c4e7410e6dba.svg";
export { ForwardRef as ReactComponent };